import { useState } from 'react';

export function usePagination(initialLimit: number = 10) {
  const [limit, setLimit] = useState(initialLimit);
  const [offset, setOffset] = useState(0);

  const resetPagination = () => {
    setOffset(0);
  };

  return {
    limit,
    offset,
    setLimit,
    setOffset,
    resetPagination,
  };
}
